var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

(function(Wishlist, $) {
    var $wishlistButton = $(".wishlist-btn"),
        $wishlistTile = $(".wishlist-tile-container"),
        $wishlistItemCount = $(".wishlist-item-count"),
        numProductTiles = $wishlistTile.length,
        wishlist = localStorage.getItem("user_wishlist") || [];
    wishlist.length > 0 && (wishlist = JSON.parse(localStorage.getItem("user_wishlist")));
    var animateWishlist = function(self) {
            $(self).toggleClass("is-active")
        },
        updateWishlist = function(self) {
            var productHandle = $(self).attr("data-product-handle"),
                isRemove = $(self).hasClass("is-active");
            if (isRemove) {
                var removeIndex = wishlist.indexOf(productHandle);
                wishlist.splice(removeIndex, 1), localStorage.setItem("user_wishlist", JSON.stringify(wishlist))
            } else wishlist.push(productHandle), localStorage.setItem("user_wishlist", JSON.stringify(wishlist))
            console.log(JSON.stringify(wishlist))
        },
        updateWishlistNew = function(self) {
            var productHandle = self;
            // var removeIndex = wishlist.indexOf(productHandle);
            // wishlist.splice(removeIndex, 1); 
            // localStorage.setItem("user_wishlist", JSON.stringify(wishlist));
            wishlist.push(productHandle); 
            localStorage.setItem("user_wishlist", JSON.stringify(wishlist));
            console.log(JSON.stringify(wishlist));
        },
        activateItemsInWishlist = function() {
            $wishlistButton.each(function() {
                var productHandle = $(this).attr("data-product-handle");
                wishlist.indexOf(productHandle) > -1 && $(this).addClass("is-active")
            })
        },
        displayOnlyWishlistItems = function() {
            for (var product_handle = String(wishlist).split(","), i = 0; i < product_handle.length; i++) {
                var productHandle = product_handle[i];
                if(productHandle != "insureship-coverage"){
                $.getJSON("/products/" + productHandle + ".js", function(product) {
                    var title_heading = product.title,
                        title = product.title,
                        url = product.url,
                        handle = product.handle,
                        price = 0,
                        original_price = 0,
                        textPrice = "",
                        tags = product.tags;
                    
                    var SPrice = 0;
                    $(product.variants).each(function(i2, v) {
                        var variant = v;
                        variant && (SPrice = variant.price, variant.compare_at_price > variant.price ? (price = Shopify.formatMoney(variant.price, ""), original_price = Shopify.formatMoney(variant.compare_at_price, ""), textPrice = '<span class="ProductItem__Price Price Price--compareAt Text--subdued">' + original_price + '</span><span class="ProductItem__Price Price Price--highlight Text--subdued">' + price + "</span>") : (price = Shopify.formatMoney(variant.price, ""), textPrice = '<span class="ProductItem__Price Price Price--highlight Text--subdued">' + price + "</span>"))
                    });
                  
                    var images = product.media,
                        image_embed = "";
                    $(images).each(function(i2, image) {
                        i2 < 1 && (image_embed = '<img class="ProductItem__Image Image--fadeIn lazyautosizes Image--lazyLoaded" data-widths="[600,700,800,900,1000,1200]" data-sizes="auto" alt="' + title + '" title="' + title + '" data-media-id="' + image.id + '" sizes="410px" src="' + image.src + '"></div>', image_embed = image_embed.replace(".jpg", "_500x.jpg").replace(".png", "_500x.png").replace(".jpeg", "_500x.jpeg").replace(".webp", "_500x.webp").replace(".gif", "_500x.gif"))
                    });
                    var wishlistBtn = '<div class="img-buttons"><span class="nws-wishlist-btn" data-product-handle="' + handle + '" ><a class="action--wishlist tile-actions--btn flex wishlist-btn is-active" href="#" data-product-handle="' + handle + '">✕</a></span></div>';
                    $(".nws-wishlist-grid").append('<div class="ProductItem nws-wishlist-grid-item"><div class="ProductItem__Wrapper">' + wishlistBtn + '<a href="' + url + '" class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage"><div class="AspectRatio AspectRatio--withFallback" style="max-width: 2500px; padding-bottom: 100.0%; --aspect-ratio: 1.0">' + image_embed + '</div></a><div class="ProductItem__LabelList"><div class="ProductItem__Info ProductItem__Info--center"><a href="' + url + '"><h3 class="ProductItem__Title Heading"><div class="ProductMeta__Title Heading u-h7">' + title_heading + '</div></h3></a><div class="ProductItem__PriceList  Heading">' + textPrice + '</div><a href="' + url + '" class="Button Button--primary Button--full" >View Product</a></div></div></div>'), $(".wishlist-grid .nws-wishlist-grid .nws-wishlist-btn").click(function() {
                        var handleV = $(this).attr("data-product-handle");
                        wishlist = $.grep(wishlist, function(value) {
                            return value != handleV
                        }), localStorage.setItem("user_wishlist", JSON.stringify(wishlist)), $(this).parent().parent().parent().hide()
                    })
                });
              }
            }
            String(wishlist) != "" && (numProductTiles = 1)
        },
        loadWishlist = function() {
            window.location.href.indexOf("pages/wishlist") > -1 && (displayOnlyWishlistItems(), $(".wishlist-loader").fadeOut(2e3, function() {
                $(".wishlist-grid").addClass("is_visible"), $(".wishlist-hero").addClass("is_visible"), console.log(numProductTiles), numProductTiles == 0 ? $(".wishlist-grid--empty-list").addClass("is_visible") : $(".wishlist-grid--empty-list").hide()
            }))
        },
        updateWishlistItemCount = function() {
            wishlist && $wishlistItemCount.text(wishlist.length)
        },
        bindUIActions = function() {
            $wishlistButton.click(function(e) {
                e.preventDefault(), updateWishlist(this), animateWishlist(this)
            })
        };
    Wishlist.init = function() {
        bindUIActions(), activateItemsInWishlist(), loadWishlist(), updateWishlistItemCount()
    }

    var user_wishlist_time = localStorage.getItem("user_wishlist_time");
    $.ajax({
      type: 'GET',
      url: '/cart.json',
      dataType: 'json',
      success: function(data) { 
        var item_count = data.item_count;
        if(item_count > 0){
         if(user_wishlist_time == ''){
            var myDate = new Date(new Date().getTime()+(9*24*60*60*1000)); //9 days
            localStorage.setItem("user_wishlist_time", myDate.getDate());
          }else{
            var myDate = new Date(new Date().getTime());
            var chkDate = myDate.getDate();
            var interval = setInterval(function(){
               if(user_wishlist_time == chkDate){
                  $.each(data.items , function(index, val) { 
                    updateWishlistNew(val.handle);
                  }); 
                  localStorage.setItem("user_wishlist_time", "");
                  clearInterval(interval);
               }
             }, 1000); 
          }
        }
      }
    });
  
})(window.Wishlist = window.Wishlist || {}, jQuery, void 0);